import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import logo_footer from '../images/logo_footer.png';

import { Link } from 'react-router-dom';
export default function Footer() {
  return (


    <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
        

        <div>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="facebook-f" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="twitter" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="google" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="instagram" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="linkedin" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="github" />
          </a>
        </div>
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4 d-flex flex-column align-items-center'>
              {/* <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                Isimm
              </h6> */}
              <img
        src={logo_footer}
        className="img-fluid "
        alt="Footer Logo"
        style={{ width: '120px', height: 'auto',marginBottom:'10px' }} // Adjust the width as needed
      />
              <p>
              L’association EL WIFAK est une association de développement qui est fondée en 1998, elle est spécialisée dans le développement économique local, l’environnement et la micro-finance.
              </p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>DOMAINES DE L'ASSOCIATION</h6>
              <p>Citoyenneté et gouvernance </p>
              <p>Développement économique et social</p>
              <p>Développement local</p>
            
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>LIENS UTILES</h6>
              <p style={{ color: '#00674b' }}>
              <Link to="/lesetatsfinanciers" className='text-reset'>Les états financiers</Link>
              </p>
              <p style={{ color: '#00674b' }}>
              <Link to="/Comite" className='text-reset'>Comité</Link>
              </p>
             <p style={{ color: '#00674b' }}> 
              <Link to="/documents-a-telecharger" className='text-reset'> Documents à télécharger  </Link>
              </p>
              <p style={{ color: '#00674b' }}>
              <Link to="/references-juridiques" className='text-reset'>Les Références Juridiques</Link>
              </p>
              <p style={{ color: '#00674b' }}>
              <a href="https://www.facebook.com/WifakBargou" className="text-reset" target="_blank" rel="noopener noreferrer">Page Facebook </a>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4 ' 
              >CONTACT</h6>
              <p>
                
                Avenue Habib Bourguiba, Bargou 6170 Siliana 
                 
              </p>
              <p>
              
                wifakbargou10@gmail.com
                </p>
              <p>
             +216 78 896 560
              </p>
              <p>
                 +216 98 238 554              </p>
                 <p> +216 92 394 681</p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
      
      </div>
    </MDBFooter>
  );
}